import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar, A11y } from 'swiper';

const BestRooms = (props) => {
    const data = props.data;

    return (
        <section className="tf-section best-rooms">

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center">
                            <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Rooms</span></h1>
                            <h5 className="sub-title mb-10 text-black" data-aos="fade-up" data-aos-duration="1000">Nuestras Habitaciones</h5>
                        </div>
                    </div>
                </div>
                <div className="row mt-50">
                    <div className="col-12" data-aos="fade-up" data-aos-duration="1000">
                        <Swiper
                            className="best-rooms-swiper"
                            modules={[Navigation, Scrollbar, A11y]}
                            spaceBetween={30}
                            navigation={true}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                767: { slidesPerView: 2 },
                                991: { slidesPerView: 3 },
                            }}
                        >
                            {
                                data.map((item, index) => (
                                    <SwiperSlide key={item.id || index} className="best-room-slide">
                                        <div className="best-room-card">
                                            <div className="best-room-image-container">
                                                <img src={item.img} alt={item.title} className="best-room-image" />
                                            </div>
                                            <div className="best-room-content">
                                                <h4 className="best-room-title">
                                                    {item.title}
                                                </h4>
                                                <p className="best-room-desc">
                                                    {item.desc}
                                                </p>
                                                <Link to={item.link} className="btn-action style-2 best-room-btn">
                                                    Ver mas <i className="fas fa-arrow-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BestRooms;

